module.exports = __webpack_public_path__ + "img/logo-white.cbf4aca.png";